import React from 'react';

import PlayoffBracket from './playoff-bracket';

const PLAYOFF_INITIAL_DATA = {
  round3: [[[], []]],
  round4: [[[], []], [[], []]],
  round5: [[[]]],
  semifinal: [[[]], [[]]],
  final: [[[]]]
};

const PlayoffBracketActive = () => <PlayoffBracket matches={PLAYOFF_INITIAL_DATA} />;

export default PlayoffBracketActive;
